"use client";
import React from "react";
import { motion } from "motion/react";

interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  animate?: boolean;
  onClick?: () => void;
}

function GlassCardContent({ children }: { children: React.ReactNode }) {
  return (
    <>
      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none rounded-[inherit]"
      />
      {children}
      <div className="absolute inset-0 pointer-events-none rounded-[inherit] glass-shadow-inset" />
    </>
  );
}

export const GlassCard: React.FC<GlassCardProps> = ({
  children,
  className = "",
  hover = true,
  animate = true,
  onClick,
}) => {
  const baseClasses = `
    backdrop-blur-[5px] bg-white/10 dark:bg-white/5
    border border-white/20 dark:border-white/10
    rounded-[33px]
    glass-shadow-outer
    relative
    transition-all duration-300
  `;

  const hoverClasses = hover
    ? `
    hover:bg-white/15 dark:hover:bg-white/8
    hover:shadow-[var(--shadow-glass-outer-hover)]
    hover:border-white/30 dark:hover:border-white/15
    hover:scale-[1.01]
    hover:-translate-y-0.5
  `
    : "";

  if (animate) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className={`${baseClasses} ${hoverClasses} ${className}`}
        onClick={onClick}
      >
        <GlassCardContent>{children}</GlassCardContent>
      </motion.div>
    );
  }

  return (
    <div
      className={`${baseClasses} ${hoverClasses} ${className}`}
      onClick={onClick}
    >
      <GlassCardContent>{children}</GlassCardContent>
    </div>
  );
};
